<app-breadcrumb [title]="'Tus Pedidos'" [breadcrumb]="'Tus Pedidos'"></app-breadcrumb>

<!-- section start -->
<section class="contact-page register-page">
  <div class="container" id="container">

    <div class="row d-flex justify-content-center">
      <div class="col-md-6">
        <h3>Compras:</h3>
      </div>
      <div class="col-md-6">
        <h4 class="pull-right compras">
          Pedidos realizados | Detalle de las compras
        </h4>
        <p class="pull-right">
          Para ver el estado de tu pedido, vuelve al resumen individual del
          pedido.
        </p>
      </div>
      <!-- <div class="col-6"></div> -->
      <div class="col-12">
        <div class="row">
          <div class="dx-field">
            <div class="dx-field-value">
              <dx-date-range-box [(value)]="currentValue" (onValueChanged)="currentValueChanged($event)"
                [displayFormat]="'dd/MM/yyyy'">
              </dx-date-range-box>
            </div>
          </div>
        </div>
      </div>

      <section class="section-b-space pt-3" style="width: 90%">
        <ng-container *ngFor="let orden of pedidos">
          <div class="row card-producto-resumen justify-content-center">
            <div class="col-6 d-flex justify-content-start p-3 pb-0 align-items-center">
              <h6 class="">Detalle de la compra</h6>
            </div>
            <div class="col-6 d-flex justify-content-end p-3 pb-0 align-items-center">
              <h6>Compra realizada el {{ orden.fhregistro | date:'d \'de\' MMMM \' y':'':'es' | titlecase }}</h6>
            </div>
            <!-- <div class="col-6 col-md-12 d-flex justify-content-end" *ngIf="orden.estatus === 0">
              <button class="cancel-btn" (click)="openCancelModal(orden)"><span style="color: red;"><i class="fa fa-circle-o" aria-hidden="true"></i></span> Cancelar Pedido </button>
            </div> -->
            <ng-container *ngFor="let producto of orden.productos">
              <div class="row product-order-detail d-flex justify-content-center item-card-border-bottom">
                <div class="col-0 col-md-2 pl-5 pt-2 mb-0 d-flex align-items-center justify-content-center">
                  <img src="{{ producto.imagen }}" alt="" class="img-fluid" style="max-height: 50px; width: auto" />
                </div>
                <div class="col-md-3 col-12 px-3 py-2">
                  <div class="alinear-txt d-flex flex-column justify-content-startalign-items-start">
                    <div class="style-h6 d-flex">
                      <h6 class="fw-bold">Producto:</h6>
                      &nbsp;&nbsp;&nbsp;
                      <h6>{{ producto.nombreProducto }}</h6>
                    </div>
                    <div class="d-flex style-h6 w-100">
                      <h6 class="fw-bold">Cantidad:</h6>
                      &nbsp;&nbsp;&nbsp;
                      <h6>{{ producto.cantidad }}</h6>
                    </div>
                    <div class="d-flex style-h6 w-100">
                      <h6 class="fw-bold">Precio:</h6>
                      &nbsp;&nbsp;&nbsp;
                      <h6 *ngIf="producto.precioPromocion === 0">{{producto.precio | currency:'':'symbol':'1.2-2' }}
                      </h6>
                      <h6 *ngIf="producto.precioPromocion > 0">{{producto.precioPromocion | currency:'':'symbol':'1.2-2'
                        }}&nbsp;&nbsp;
                        <del><span class="money">{{producto.precio | currency:'':'symbol':'1.2-2' }}</span></del>
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-md-5 col-12 d-flex align-items-start py-2 style-h6 flex-column">
                  <h6 class="fw-bold pr-5">Descripción:</h6>
                  <textarea name="" class="inputDescripcion" readonly="readonly">{{ producto.descripcion }}</textarea>
                  <!-- <h6 style="text-overflow: ellipsis;">{{producto.descripcion}}</h6> -->
                </div>
                <div class="col-md-2 col-12 d-flex align-items-start py-2 style-h6 flex-column" *ngIf="orden.estatus === 0 || orden.estatus === 1">
                  <button class="btn-solid btn" style="align-self: center; width: 100% !important;" (click)="cancelarOrden(orden.idOrden)"
                    data-open="moldalEstatus">Cancelar</button>
                </div>
              </div>
            </ng-container>
            <div class="row resumen-compra m-0 d-flex flex-row py-2">
              <div
                class="col-md-3 col-12 d-flex align-items-start p-3 flex-column justify-content-center item-card-border-bottom2">
                <div class="mb-1 d-flex style-h6">
                  <h6 class="fw-bold">N° de Pedido:</h6>
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="m-0">{{ orden.numeroOrden }}</h6>
                </div>
                <div class="mb-1 d-flex style-h6">
                  <h6 class="fw-bold">Método de pago:</h6>
                  &nbsp;&nbsp;
                  <div>
                    <img [id]="'ordenId'+orden.idOrden" src="assets/images/icon/{{ orden.cardBrand }}.png" alt="" />
                  </div>
                  <h6 class="m-0">
                    &nbsp;&nbsp;&nbsp; {{ orden?.last4 === 'Tarjeta' ? 'Tarjeta Bancaria' : orden?.last4 }} 
                  </h6>
                </div>
                <div class="mb-1 d-flex style-h6">
                  <h6 class="fw-bold"
                    [ngClass]="{'color-preautorizado': orden.estatus === 0, 'color-pagado': orden.estatus === 1, 'color-cancelado': orden.estatus !== 0 && orden.estatus !== 1}">
                    Estatus:</h6>
                  &nbsp;&nbsp;&nbsp;
                  <!-- <h6 class="m-0 ">{{orden.estatus}}</h6> -->
                  <h6 class="m-0"
                    [ngClass]="{'color-preautorizado': orden.estatus === 0, 'color-pagado': orden.estatus === 1, 'color-cancelado': orden.estatus !== 0 && orden.estatus !== 1}">
                    {{
                    orden.estatus === 0 ? 'Preautorizado' :
                    orden.estatus === 1 ? 'Pagado' :
                    'Cancelado'
                    }}</h6>
                </div>

              </div>
              <div class="col-md-4 col-12 align-items-center pedidos-btn p-3 item-card-border-bottom2">
                <div class="col d-flex text-center flex-column justify-content-center style-h6">
                  <h6 class="fw-bold pb-2">Seguimiento al Pedido y Facturación:</h6>
                  <button class="btn-solid btn" style="align-self: center;" (click)="irAEstatus(orden)"
                    data-open="moldalEstatus">Rastrear y Facturar</button>
                </div>
              </div>
              <div class="col-md-3 col-6 d-flex p-3 align-items-start jus item-card-border-left flex-column py-0">
                <div class="row d-flex style-h6">
                  <h6 class="fw-bold mb-0">Productos:</h6>
                  <h6 class="fw-bold mb-0">Descuento promocional:</h6>
                  <h6 class="fw-bold mb-0">Descuento por cupón:</h6>
                  <h6 class="fw-bold mb-0">Subtotal:</h6>
                  <h6 class="fw-bold mb-0">Envío:</h6>
                </div>
                <div class="row mt-2">
                  <h5 class="m-0 fw-bold"
                    [ngClass]="{'color-preautorizado': orden.estatus === 0, 'color-pagado': orden.estatus === 1, 'color-cancelado': orden.estatus !== 0 && orden.estatus !== 1}">
                    Total(IVA incluido):
                  </h5>
                </div>
              </div>
              <div class="col-md-2 col-6 d-flex p-3 align-items-end flex-column style-h6 py-0">
                <h6 class="fw-bold mb-0">{{ orden.productosTotal | currency:'':'symbol':'1.2-2' }}</h6>
                <h6 class="fw-bold mb-0">{{ orden.montoDescDoropeel | currency:'':'symbol':'1.2-2' }}</h6>
                <h6 class="fw-bold mb-0">{{ orden.descuento - orden.montoDescDoropeel | currency:'':'symbol':'1.2-2' }}
                </h6>
                <h6 class="fw-bold mb-0">{{ orden.productosTotal - orden.descuento | currency:'':'symbol':'1.2-2' }}
                </h6>
                <h6 class="fw-bold mb-0" *ngIf="orden.envio > 0; else envioGratis">{{ orden.envio |
                  currency:'':'symbol':'1.2-2'}}</h6>
                <ng-template #envioGratis>
                  <h6 class="mb-0 delivery-txt" style="color: #176ec0 !important;">Envío Gratis</h6>
                </ng-template>
                <div class="row">
                  <h5 class="m-0 fw-bold"
                    [ngClass]="{'color-preautorizado': orden.estatus === 0, 'color-pagado': orden.estatus === 1, 'color-cancelado': orden.estatus !== 0 && orden.estatus !== 1}">
                    {{ orden.total | currency:'':'symbol':'1.2-2' }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </section>
    </div>
    <div class="col-sm-12 empty-cart-cls text-center" *ngIf="sinCompras">
      <img src="assets/images/icon-empty-cart.png" class="img-fluid mb-4">
      <h3><strong>No hay pedidos para mostrar</strong></h3>
      <h4>Compra algo para ser feliz :)</h4>
      <br>
      <br>
      <br>
    </div>
  </div>
</section>